import { Snackbar, Button, IconButton } from '@material-ui/core';
import { CloseSharp } from '@material-ui/icons';
import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';


const ContactForm = () => {

    const [forms, setForms] = useState({
        name: '',
        email: '',
        subject: '',
        phone: '',
        message: ''
    });
    const [open, setOpen] = React.useState(false);
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));
    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = e => {
        e.preventDefault();
        if (validator.allValid()) {
            validator.hideMessages();
            var hookUrl = "https://script.google.com/macros/s/AKfycbyh2pEtejuK6WGIC2eVVyCkajr_wR9Wv3D6mI4rd-5IQRp5M7g/exec?method=doPost";
            var formData = { "name": forms['name'], "email": forms['email'], "to": 'b4affan@gmail.com', "subject": forms['subject'], "message": forms['message'] + "\nPhone: " + forms['phone'] };
            fetch(hookUrl, {
                redirect: "follow",
                method: "POST",
                body: JSON.stringify(formData),
                headers: {
                    "Content-Type": "text/plain;charset=utf-8",
                },
            });
            setOpen(true);
            setForms({
                name: '',
                email: '',
                subject: '',
                phone: '',
                message: ''
            })
        } else {
            validator.showMessages();
        }
    };
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseSharp fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <>

            <form onSubmit={(e) => submitHandler(e)} className="contact-validation-active" >
                <div className="row">
                    <div className="col col-lg-6 col-12">
                        <div className="form-field">
                            <input
                                value={forms.name}
                                type="text"
                                name="name"
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                                placeholder="Your Name" />
                            {validator.message('name', forms.name, 'required|alpha_space')}
                        </div>
                    </div>
                    <div className="col col-lg-6 col-12">
                        <div className="form-field">
                            <input
                                value={forms.email}
                                type="email"
                                name="email"
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                                placeholder="Your Email" />
                            {validator.message('email', forms.email, 'required|email')}
                        </div>
                    </div>
                    <div className="col col-lg-12 col-12">
                        <div className="form-field">
                            <input
                                value={forms.phone}
                                type="phone"
                                name="phone"
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                                placeholder="Your phone" />
                            {validator.message('phone', forms.phone, 'required|phone')}
                        </div>
                    </div>
                    <div className="col col-lg-12 col-12">
                        <div className="form-field">
                            <select
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                                value={forms.subject}
                                type="text"
                                name="subject">
                                <option>Choose a Service</option>
                                <option>Mobile Apps</option>
                                <option>Web Development</option>
                                <option>Software Development</option>
                            </select>
                            {validator.message('subject', forms.subject, 'required')}
                        </div>
                    </div>
                    <div className="col col-lg-12 col-12">
                        <textarea
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            value={forms.message}
                            type="text"
                            name="message"
                            placeholder="Message">
                        </textarea>
                        {validator.message('message', forms.message, 'required')}
                    </div>
                </div>
                <div className="submit-area">
                    <button type="submit" className="theme-btn">Submit Now</button>
                </div>
            </form>
            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                message="Message sent"
                action={action}
            />
        </>
    )
}

export default ContactForm;